import moment from 'moment-timezone';

// Some browsers return an empty/undefined timeZone when the OS zone isn't recognized by
// their ICU data (e.g. Manitoba 2026). Calling `.tz(undefined)` acts as a getter and returns
// undefined, so fall back to the browser's local offset instead. Zone resolution can also
// throw in some environments, which gets the same fallback.
export default function tzTime(time: string | Date) {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zone && moment.tz.zone(zone)) {
      return moment(time).tz(zone);
    }
  } catch {
    // fall through to local time
  }
  return moment(time);
}
